module.exports = __webpack_public_path__ + "img/diamont-icon.9da1c007.svg";